import React from "react";
import { Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const EventCard = () => {
  const navigate = useNavigate();

  const event = {
    id: 1,
    name: "Sangeet Night",
    date: "12 Dec 2025",
    startTime: "7:00 PM",
    venue: "Grand Palace, Lucknow",
    theme: "Bollywood Night",
    dressCode: "Traditional",
    dressColor: "Golden & Red",
  };

  return (
    <>
      <h2
        className="mb-4 user-detail-title font-fm"
        style={{ fontSize: "50px", color: "maroon" }}
      >
        Events
      </h2>

      <Card className="shadow-lg event-card mb-5">
        <Card.Body>
          <div
            key={event.id}
            className="event-item mb-4 p-3 rounded d-flex justify-content-between align-items-center"
          >
            {/* Left side - Event details */}
            <div>
              <h5 className="fw-bold mb-3" style={{ color: "maroon" }}>
                {event.name}
              </h5>

              <div className="d-flex justify-content-between mb-1">
                <strong className="label-text me-5">Date:</strong>
                <span>{event.date}</span>
              </div>

              <div className="d-flex justify-content-between mb-1">
                <strong className="label-text">Start Time:</strong>
                <span>{event.startTime}</span>
              </div>

              <div className="d-flex justify-content-between mb-1">
                <strong className="label-text me-5">Venue:</strong>
                <span>{event.venue}</span>
              </div>

              <div className="d-flex justify-content-between mb-1">
                <strong className="label-text">Theme:</strong>
                <span>{event.theme}</span>
              </div>

              <div className="d-flex justify-content-between mb-1">
                <strong className="label-text">Dress Code:</strong>
                <span>{event.dressCode}</span>
              </div>

              <div className="d-flex justify-content-between mb-1">
                <strong className="label-text">Dress Color:</strong>
                <span>{event.dressColor}</span>
              </div>
            </div>

            {/* Right side - Buttons */}
            <div className="ms-3 d-flex flex-column gap-2">
              <Button
                className="maroon-btn"
                onClick={() => navigate(`/sub-events`)}
                style={{ backgroundColor: "maroon", border: "none" }}
              >
                Sub Events
              </Button>

              <Button
                className="maroon-btn"
                onClick={() => navigate(`/tasks`)}
                style={{ backgroundColor: "maroon", border: "none" }}
              >
                Tasks
              </Button>

            
              <Button
                className="maroon-btn"
                onClick={() => navigate(`/guests`)}
                style={{ backgroundColor: "maroon", border: "none" }}
              >
                Guest Listing
              </Button>
            </div>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default EventCard;
